import AuthenticatedUserContext, {
	type AuthenticatedUserContextValue,
} from '@UI/Providers/AuthenticatedUserProvider/AuthenticatedUserContext';
import * as React from 'react';

/**
 * Reserved for components mounted under `RequireSession`: in `authenticatedUserStore`, every
 * transition that sets `sessionStatus` to `'authenticated'` also builds a user view, and every
 * transition that sets `user` to `null` sets a non-authenticated status — so the two are
 * equivalent, and `RequireSession` already redirects to `/login` unless the status is
 * `'authenticated'`. Anything else — a provider mounted above the `Routes`, an anonymous screen, a
 * route guard — must use `useAuthenticatedUser` instead, which tolerates a `null` user.
 */
function useStrictAuthenticatedUser(): { user: NonNullable<AuthenticatedUserContextValue['user']> } {
	const context = React.useContext(AuthenticatedUserContext);

	if (context === null) {
		throw new Error('useStrictAuthenticatedUser must be used within an AuthenticatedUserProvider.');
	}

	if (context.user === null) {
		throw new Error('useStrictAuthenticatedUser must be used when user is authenticated.');
	}

	return { user: context.user };
}

export default useStrictAuthenticatedUser;
